var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclaimCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c9267d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 1a27.007 27.007 0 00-10.509 51.879A27.007 27.007 0 0038.509 3.121 26.83 26.83 0 0028 1m0-1A28 28 0 110 28 28 28 0 0128 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.016 43.968A2 2 0 0030.08 42a2.009 2.009 0 00-2.064-2.02A1.969 1.969 0 0026 42a1.958 1.958 0 002.016 1.968zm-.72-7.728h1.488L29.648 12h-3.264z"
  }))));
}
export default "/_next/static/assets/public/icons/general/91c872a887e37756706120dc5d3a5db7.svg";
export { SvgExclaimCircle as ReactComponent };